<app-create-asin-header></app-create-asin-header>

<div class="land-bg" [style]="minHeight">
    <div class="container mb-4" [style]="minHeight2">
        <div style="padding: 50px 30px;">
            <div class="row justify-content-center">
                <div class="col-md-10">

                    <div class="question-card">
                        <form>
                            <div class="card-container">
                                <p style="font-size: 18px;font-weight: 500">Information Preview</p>
                                <br />

                                <div class="p-2">
                                    <div class="row personal-info-panel">
                                        <p class="mb-4">Business Information</p>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Business Name</label>
                                                <input value="{{form.get('businessDetails')?.get('business_name')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>CAC RC Number (RC/IT/LP/LLP)</label>
                                                <input value="{{form.get('businessDetails')?.get('rcNumber')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Email</label>
                                                <input value="{{form.get('businessDetails')?.get('email')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="row">
                                        <div class="col-md-12 mb-3">
                                            <div class="input-group-div">
                                                <label>Address</label>
                                                <input value="{{form.get('businessInformation')?.get('businessAddress')?.value}}" readonly />
                                            </div>
                                        </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Business Category</label>
                                                <input value="{{form.get('businessInformation')?.get('businessCategory')?.value.split('-')[0]}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>No. Of Staffs</label>
                                                <input value="{{form.get('businessInformation')?.get('numberOfEmployees')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>No. Of Branches</label>
                                                <input value="{{form.get('businessInformation')?.get('numberOfBranches')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Web Address</label>
                                                <input value="{{form.get('businessInformation')?.get('webAddress')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Date Of Commencement</label>
                                                <input value="{{form.get('businessInformation')?.get('dateOfCommencement')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Business Address</label>
                                                <input value="{{form.get('businessInformation')?.get('businessAddress')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>State</label>
                                                <input value="{{form.get('businessInformation')?.get('businessState')?.value.split('-')[1]}}" readonly />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>

                                <div class="p-2">
                                    <div class="row personal-info-panel">
                                        <p class="mb-4">Contact Person Information</p>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>First Name</label>
                                                <input value="{{form.get('businessInformation')?.get('businessContactFirstName')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Last Name</label>
                                                <input value="{{form.get('businessInformation')?.get('businessContactLastName')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Email</label>
                                                <input value="{{form.get('businessInformation')?.get('businessContactEmail')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Phone</label>
                                                <input value="{{form.get('businessInformation')?.get('businessContactPhoneNumber')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Designation</label>
                                                <input value="{{form.get('businessInformation')?.get('businessContactPosition')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Address</label>
                                                <input value="{{form.get('businessInformation')?.get('businessContactAddress')?.value}}" readonly />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <br>
                                <div class="p-2">
                                    <div class="row personal-info-panel">
                                        <p class="mb-4">Other Information</p>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Landlord Name</label>
                                                <input value="{{form.get('businessInformation')?.get('landLordName')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Landlord Address</label>
                                                <input value="{{form.get('businessInformation')?.get('landLordAddress')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Landlord Phone</label>
                                                <input value="{{form.get('businessInformation')?.get('landLordPhoneNumber')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Business type</label>
                                                <input value="{{form.get('businessInformation')?.get('businessType')?.value}}" readonly />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Date of Incorporation</label>
                                                <input value="{{form.get('businessInformation')?.get('dateOfIncorporation')?.value}}" readonly />
                                            </div>
                                        </div>

                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div small-checkbox">
                                                <label>Do you own a Vehicle</label>
                                                <input [checked]="form.get('businessInformation')?.get('hasVehicle')?.value" [disabled]="true" type="checkbox" />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div small-checkbox">
                                                <label>Do you own a Property</label>
                                                <input [checked]="form.get('businessInformation')?.get('hasCorporateProperty')?.value" [disabled]="true" type="checkbox" />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div small-checkbox">
                                                <label>Do you own an Asset</label>
                                                <input [checked]="form.get('businessInformation')?.get('hasCorporateAsset')?.value" [disabled]="true" type="checkbox" />
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div small-checkbox">
                                                <label>Business Contact Address</label>
                                                <input [checked]="form.get('businessInformation')?.get('businessContactAddress')?.value" [disabled]="true" type="checkbox" />
                                            </div>
                                        </div>
                                        
                                        <!-- <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Do you own a Vehicle</label>
                                                <input [checked]="form.get('businessInformation')?.get('hasVehicle')?.value" [disabled]="true"  type="checkbox"/>
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Do you own a Property</label>
                                                <input [checked]="form.get('businessInformation')?.get('hasCorporateProperty')?.value" [disabled]="true" readonly type="checkbox"/>
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Do you own an Asset</label>
                                                <input [checked]="form.get('businessInformation')?.get('hasCorporateAsset')?.value" [disabled]="true" readonly  type="checkbox"/>
                                            </div>
                                        </div>
                                        <div class="col-md-4 mb-3">
                                            <div class="input-group-div">
                                                <label>Do you own a Vehicle</label>
                                                <input [checked]="form.get('businessInformation')?.get('businessContactAddress')?.value" [disabled]="true" readonly type="checkbox"/>
                                            </div>
                                        </div> -->
                                    </div>
                                </div>

                                <br />
<!--                                <p class="mb-1 fw-bold">Answer Basic Information</p>-->

<!--                                <div class="p-2 pt-0">-->
<!--                                    <div class="row personal-info-panel">-->
<!--                                        <div class="d-flex flex-row align-items-center mb-4">-->
<!--                                            <span class="me-4" style="color: #666;font-size: 14px;">Is address rented?</span>-->
<!--                                            <div class="d-flex flex-row align-items-center">-->
<!--                                                <div *ngIf="prevData?.isBusinessAddressRented" class="d-flex flex-row align-items-center me-4">-->
<!--                                                    <label style="font-size: 12px;" class="me-2">Yes</label>-->
<!--                                                    <input type="radio" checked />-->
<!--                                                </div>-->
<!--                                                <div *ngIf="!prevData?.isBusinessAddressRented" class="d-flex flex-row align-items-center">-->
<!--                                                    <label style="font-size: 12px;" class="me-2">No</label>-->
<!--                                                    <input type="radio" checked />-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-4 mb-3">-->
<!--                                            <div class="input-group-div">-->
<!--                                                <label>Landlord Full Name</label>-->
<!--                                                <input value="{{prevData?.landLordName}}" />-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-4 mb-3">-->
<!--                                            <div class="input-group-div">-->
<!--                                                <label>Phone Number</label>-->
<!--                                                <input value="{{prevData?.landLordPhoneNumber}}" readonly />-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-4 mb-3">-->
<!--                                            <div class="input-group-div">-->
<!--                                                <label>Address</label>-->
<!--                                                <input value="{{prevData?.landLordAddress}}" readonly />-->
<!--                                            </div>-->
<!--                                        </div>-->

<!--                                    </div>-->
<!--                                </div>-->

<!--                                <br />-->

<!--                                <div class="p-2">-->
<!--                                    <div class="row personal-info-panel">-->
<!--                                        <div class="d-flex flex-row align-items-center mb-4">-->
<!--                                            <span class="me-4" style="color: #666;font-size: 14px;">Is business Reg. with CAC?</span>-->
<!--                                            <div class="d-flex flex-row align-items-center">-->
<!--                                                <div *ngIf="prevData?.registeredWithCac" class="d-flex flex-row align-items-center me-4">-->
<!--                                                    <label style="font-size: 12px;" class="me-2">Yes</label>-->
<!--                                                    <input type="radio" checked />-->
<!--                                                </div>-->
<!--                                                <div *ngIf="!prevData?.registeredWithCac" class="d-flex flex-row align-items-center">-->
<!--                                                    <label style="font-size: 12px;" class="me-2">No</label>-->
<!--                                                    <input type="radio" checked />-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-4 mb-3">-->
<!--                                            <div class="input-group-div">-->
<!--                                                <label>RC Number</label>-->
<!--                                                <input value="{{prevData?.rcNumber}}" />-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-4 mb-3">-->
<!--                                            <div class="input-group-div">-->
<!--                                                <label>Date Of Incorporation</label>-->
<!--                                                <input value="{{prevData?.dateOfIncorporation}}" readonly />-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-4 mb-3">-->
<!--                                            <div class="input-group-div">-->
<!--                                                <label>Business Type</label>-->
<!--                                                <input value="{{prevData?.businessType}}" readonly />-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->

<!--                                <br />-->

<!--                                <div class="p-2">-->
<!--                                    <div class="row personal-info-panel">-->
<!--                                        <div class="d-flex flex-row align-items-center">-->
<!--                                            <span class="me-4" style="color: #666;font-size: 14px;">Is business solely online?</span>-->
<!--                                            <div class="d-flex flex-row align-items-center">-->
<!--                                                <div *ngIf="prevData?.solelyOnline" class="d-flex flex-row align-items-center me-4">-->
<!--                                                    <label style="font-size: 12px;" class="me-2">Yes</label>-->
<!--                                                    <input type="radio" checked />-->
<!--                                                </div>-->
<!--                                                <div *ngIf="!prevData?.solelyOnline" class="d-flex flex-row align-items-center">-->
<!--                                                    <label style="font-size: 12px;" class="me-2">No</label>-->
<!--                                                    <input type="radio" checked />-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->

<!--                                <br />-->

<!--                                <div class="p-2">-->
<!--                                    <div class="row personal-info-panel">-->
<!--                                        <div class="d-flex flex-row align-items-center mb-4">-->
<!--                                            <span class="me-4" style="color: #666;font-size: 14px;">Do you own a vehicle?</span>-->
<!--                                            <div class="d-flex flex-row align-items-center">-->
<!--                                                <div *ngIf="prevData?.hasVehicle" class="d-flex flex-row align-items-center me-4">-->
<!--                                                    <label style="font-size: 12px;" class="me-2">Yes</label>-->
<!--                                                    <input type="radio" checked />-->
<!--                                                </div>-->
<!--                                                <div *ngIf="!prevData?.hasVehicle" class="d-flex flex-row align-items-center">-->
<!--                                                    <label style="font-size: 12px;" class="me-2">No</label>-->
<!--                                                    <input type="radio" checked />-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-4 mb-3">-->
<!--                                            <div class="input-group-div">-->
<!--                                                <label>Enter No. Of Vehicle</label>-->
<!--                                                <input value="{{prevData?.vehicleCount}}" readonly />-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <br />-->

<!--                                <div class="p-2">-->
<!--                                    <div class="row personal-info-panel">-->
<!--                                        <div class="d-flex flex-row align-items-center mb-4">-->
<!--                                            <span class="me-4" style="color: #666;font-size: 14px;">Do You Own A Property?</span>-->
<!--                                            <div class="d-flex flex-row align-items-center">-->
<!--                                                <div *ngIf="!prevData?.hasCorporateProperty" class="d-flex flex-row align-items-center me-4">-->
<!--                                                    <label style="font-size: 12px;" class="me-2">Yes</label>-->
<!--                                                    <input type="radio" checked />-->
<!--                                                </div>-->
<!--                                                <div *ngIf="!prevData?.hasCorporateProperty" class="d-flex flex-row align-items-center">-->
<!--                                                    <label style="font-size: 12px;" class="me-2">No</label>-->
<!--                                                    <input type="radio" checked />-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-4 mb-3">-->
<!--                                            <div class="input-group-div">-->
<!--                                                <label>Enter No. Of Property</label>-->
<!--                                                <input value="{{prevData?.corporatePropertyCount}}" readonly />-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
<!--                                <br />-->

<!--                                <div class="p-2">-->
<!--                                    <div class="row personal-info-panel">-->
<!--                                        <div class="d-flex flex-row align-items-center mb-4">-->
<!--                                            <span class="me-4" style="color: #666;font-size: 14px;">Do You Own An Asset?</span>-->
<!--                                            <div class="d-flex flex-row align-items-center">-->
<!--                                                <div *ngIf="prevData?.hasCorporateAsset" class="d-flex flex-row align-items-center me-4">-->
<!--                                                    <label style="font-size: 12px;" class="me-2">Yes</label>-->
<!--                                                    <input type="radio" checked />-->
<!--                                                </div>-->
<!--                                                <div *ngIf="!prevData?.hasCorporateAsset" class="d-flex flex-row align-items-center">-->
<!--                                                    <label style="font-size: 12px;" class="me-2">No</label>-->
<!--                                                    <input type="radio" checked />-->
<!--                                                </div>-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                        <div class="col-md-4 mb-3">-->
<!--                                            <div class="input-group-div">-->
<!--                                                <label>Describe Asset</label>-->
<!--                                                <input value="{{prevData?.corporateAssetCount}}" readonly />-->
<!--                                            </div>-->
<!--                                        </div>-->
<!--                                    </div>-->
<!--                                </div>-->
                            </div>
                            <br />
                            <div class="submit-div mt-3 row">
                                <div class="col-md-6">
                                    <button type="button" style="height: 47px" class="cancel" (click)="cancel()">Back</button>
                                </div>
                                <div class="col-md-6">
                                    <button [disabled]="saving" type="submit" class="button" (click)="submitForm()"><span *ngIf="!saving">Generate ASIN</span><span *ngIf="saving">PLEASE WAIT...</span></button>
                                </div>

                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <app-footer></app-footer>

</div>

